import { Component, ChangeDetectionStrategy, Inject, ElementRef } from '@angular/core';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@libs/overlay';
import {
    GiftOptionsDialogData,
    GiftOptionsDialogResponse
} from '@features/basket-shared/basket-gift-options-dialog/basket-gift-options-dialog.model';
import { scrollElementIntoView } from '@shared/scroll/scroll-to-element';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { IconButtonComponent } from '../../../@shared/button/icon-button/icon-button.component';
import { BasketGiftCardMessageFormComponent } from '../basket-gift-card-message-form/basket-gift-card-message-form.component';
import { BasketGiftCardOptionsComponent } from '../basket-gift-card-options/basket-gift-card-options.component';
import { BasketGiftWrappingOptionsComponent } from '../basket-gift-wrapping-options/basket-gift-wrapping-options.component';
import { NgIf } from '@angular/common';
import { NgAfterViewInitDirective } from '../../../@shared/ng-after-view-init/ng-after-view-init.directive';
import { DialogSidebarComponent } from '../../dialog/dialog-sidebar/dialog-sidebar.component';

@Component({
    selector: 'app-basket-gift-options-dialog',
    templateUrl: './basket-gift-options-dialog.component.html',
    styleUrls: ['./basket-gift-options-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogSidebarComponent, NgAfterViewInitDirective, NgIf, BasketGiftWrappingOptionsComponent, BasketGiftCardOptionsComponent, BasketGiftCardMessageFormComponent, IconButtonComponent, TranslateModule, TranslateSafePipe]
})
export class BasketGiftOptionsDialogComponent {
    private giftOptionsDialogResponse: GiftOptionsDialogResponse = {};
    public allowMessage: boolean = false;

    constructor(
        public overlayRef: ImpactOverlayRef,
        private element: ElementRef,
        @Inject(IMPACT_OVERLAY_DATA) public data: GiftOptionsDialogData
    ) {}

    public onComponentViewInit(): void {
        const { type } = this.data;

        if (type === 'card' || type === 'wrapping') {
            // we need this setTimout to be sure we go to the correct place
            // when we open the overlay.
            setTimeout(() => {
                const focusEl = this.element.nativeElement.querySelector(`#${this.data.type}El`);
                scrollElementIntoView(focusEl);
            });
        }
    }

    public onGiftWrappingChange(giftWrappingId: string): void {
        this.giftOptionsDialogResponse.giftWrappingId = giftWrappingId;
    }

    /**
     * the card id never will be undefined, could be an empty string or will have a variantNo
     * @param cardId
     */
    public onCardChange(cardId: string): void {
        if (cardId) {
            this.allowMessage = true;
        } else {
            this.giftOptionsDialogResponse.giftCardText = '';
            this.allowMessage = false;
        }
        this.giftOptionsDialogResponse.giftCardId = cardId;
    }

    public onCardBodyChange(cardBody: Partial<GiftOptionsDialogResponse>): void {
        this.giftOptionsDialogResponse = { ...this.giftOptionsDialogResponse, ...cardBody };
    }

    public finishCustomization(): void {
        this.overlayRef.close(this.giftOptionsDialogResponse);
    }
}
